import React from 'react';
import {connect} from 'react-redux';
import CreateRecord from '../views/CreateRecord';
import {Header, Modal } from 'semantic-ui-react';

class ClientAddModal extends React.Component {
    constructor(props, context) {
        super(props, context);

    }

    render() {

        return (
            <Modal
                open={true}
                onClose={this.props.cancelAddNew}
                closeIcon
            >
                <Header icon='briefcase' content='Add New Client' />
                <Modal.Content>
                    <CreateRecord type="client" niceName="Client" onAddRecord={(id, link, key, name) => {this.props.onAddClient(id, link, key, name)}} />
                </Modal.Content>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        username: state.main.username,
        userId: state.main.userId,
        userRole: state.main.userRole
    };
}

export default connect(
    mapStateToProps,
    null
)(ClientAddModal);


// WEBPACK FOOTER //
// ./src/components/modals/ClientAddModal.js